export default __webpack_public_path__ + "static/media/Wheel-Wedge-Green.99322233.png";